import _implicitStylesheets from "./messageBoxNote.css";
import _implicitScopedStylesheets from "./messageBoxNote.scoped.css?scoped=true";
import _c360Icon from "c360/icon";
import _i18nLink from "i18n/link";
import _axIcon from "ax/icon";
import _pageLink from "page/link";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span${"c0"}${2}>${"t1"}</span>`;
const $fragment2 = parseFragment`<span${"c0"}${2}>${"t1"}</span>`;
const $fragment3 = parseFragment`<span class="slds-truncate link-text${0}"${"a0:title"}${2}>${"t1"}</span>`;
const stc0 = {
  classMap: {
    "message-title": true,
    "slds-m-top_medium": true,
    "slds-m-bottom_x-small": true
  },
  key: 1
};
const stc1 = {
  classMap: {
    "slds-m-right_small": true
  },
  props: {
    "iconName": "utility:info",
    "iconClass": "normal",
    "size": "x-small"
  },
  key: 2
};
const stc2 = {
  classMap: {
    "slds-m-bottom_medium": true
  },
  key: 7
};
const stc3 = {
  classMap: {
    "message-text": true
  },
  key: 8
};
const stc4 = {
  key: 10
};
const stc5 = {
  key: 11
};
const stc6 = {
  "message-link": true
};
const stc7 = {
  classMap: {
    "slds-grid": true
  },
  key: 13
};
const stc8 = {
  classMap: {
    "new-icon": true
  },
  props: {
    "size": "small",
    "icon": "new_window"
  },
  key: 16
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element} = $api;
  return [api_element("div", {
    className: api_normalize_class_name($cmp.cssClassBorder),
    key: 0
  }, [api_element("div", stc0, [!$cmp.withoutIcon ? api_custom_element("c360-icon", _c360Icon, stc1) : null, $cmp.noteTitle ? api_static_fragment($fragment1, 4, [api_static_part(0, {
    className: api_normalize_class_name($cmp.cssClassNote)
  }, null), api_static_part(1, null, api_dynamic_text($cmp.noteTitle))]) : null, !$cmp.noteTitle ? api_static_fragment($fragment2, 6, [api_static_part(0, {
    className: api_normalize_class_name($cmp.cssClassNote)
  }, null), api_static_part(1, null, api_dynamic_text($cmp.labels.noteMessageTitle))]) : null]), api_element("div", stc2, [api_element("span", stc3, [api_custom_element("i18n-link", _i18nLink, {
    props: {
      "ariaLabel": $cmp.message,
      "message": $cmp.message,
      "target": $cmp.linkTarget
    },
    key: 9
  })])]), $cmp.action ? api_element("div", stc4, [api_custom_element("page-link", _pageLink, stc5, [api_element("a", {
    classMap: stc6,
    attrs: {
      "href": $cmp.action.href,
      "title": $cmp.action.name,
      "target": $cmp.action.target
    },
    key: 12
  }, [api_element("div", stc7, [api_static_fragment($fragment3, 15, [api_static_part(0, {
    attrs: {
      "title": $cmp.action.name
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.action.name) + " ")]), $cmp.isNewWindow ? api_custom_element("ax-icon", _axIcon, stc8) : null])])])]) : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-78a8ojujlq";
tmpl.legacyStylesheetToken = "appx-messageBox_messageBoxNote";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
